import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { screenReadersOnly } from "../../theme/src";
export const ScreenReadersContent = (_a) => {
    var { children } = _a, otherProps = __rest(_a, ["children"]);
    return (_jsx(ScreenReadersContentStyled, Object.assign({}, otherProps, { children: children })));
};
const ScreenReadersContentStyled = styled.span `
  ${screenReadersOnly}
`;
//# sourceMappingURL=ScreenReadersContent.js.map